<div class="footer-section">
   <div class="wrapper-width">
    <div class="footer-content">
        <div class="footer-left">
            <div class="footer-icons">
                <img class="icon" id="CLICK_SOCIAL_NETWORKS" *ngFor="let icon of footerIcons" [src]="icon.icon" (click)="redirectToLink(icon.link)"/>
            </div>
            <div class="footer-button mt-24">
                <app-button
                        [buttonClass]="'small-purple-gradient'"
                        [iconDirection]="'left'"
                        [icon]="'assets/images/new-design-icons/Plus (white).svg'"
                        [text]="'Подать заявку'"
                        (buttonClick)="openSendBid()"
                        [buttonId]="'CLICK_APPLY_APPLICATION'"
                ></app-button>
            </div>
        </div>
        <div class="link-container">
            <div class="label">Контакты</div>
            <div class="footer-link">
                Call center
                <div class="center-phones">
                    <div class="phone">
                        <a href="tel:+7{{ 7057559595 }}"> +7 {{ '7057559595' | mask: '000 000 00 00' }} </a>
                    </div>
                    <div class="phone">
                        <a href="tel:+7{{ 7000999696 }}"> +7 {{ '7000999696' | mask: '000 000 00 00' }} </a>
                    </div>
                </div>
            </div>
            <div class="footer-link">Контроль качества</div>
            <div class="footer-link">
                Поддержка агентов по CRM
                <div class="center-phones">
                    <div class="phone">
                        <a href="tel:+7{{ 7057555601 }}"> +7 {{ '7057555601' | mask: '000 000 00 00' }} </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="link-container">
            <div class="label">Офисы</div>
            <div class="footer-link">Мангилик ел 17 офис «Коркем»</div>
            <div class="footer-link">Мангилик ел 17 офис «Казахстан»</div>
            <div class="footer-link">Керей-Жанибек Хандар 28  «ЖК Каратау»</div>
            <div class="footer-link">Улы дала 41 Офис «Панорама»</div>
            <div class="footer-link">Улы дала 41А ЖК «Панорама»</div>
            <div class="footer-link">Мангилик ел 28 ЖК «Sultan Apartments»</div>
        </div>
    </div>
    <div class="footer-logo">
        <img class="logo-icon" src="assets/images/new-design-icons/logo/logo.svg"/>
        <div class="line"></div>
        <div class="logo-text">
            <!-- <p class="date">© 2012–2024 ООО «Окко» 18+</p> -->
            Маркетплэйс видеообзоров и хороших риелторов
        </div>
    </div>
   </div>
</div>
